import React from 'react'
import * as Sentry from '@sentry/browser'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)

    if(process.env.NODE_ENV === 'production' && process.env.REACT_APP_SENTRY_DSN) {
      Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN })
    }
  }

  render() {
    return this.props.children
  }
}

export default ErrorBoundary
